import { RouteDescription } from "types";
import { appRoutes } from "./app";
import { publicRoutes } from "./public";

export const routes: RouteDescription[] = [
  ...appRoutes,
  ...publicRoutes
];
